import React from "react";
import { classNames } from "./utils/classNames";
export var Placeholder = function (_a) {
    var _b = _a.width, width = _b === void 0 ? "100%" : _b, className = _a.className;
    return (React.createElement("span", { className: classNames("placeholder animated", className), style: { width: width } }));
};
